

























import Vue from 'vue'

export default Vue.extend({
  name: 'StatCard',
  props: {
    value: { type: [String, Number], default: 0 },
    label: { type: String, default: '' },
    icon: { type: String, default: 'mdi-chart-box' },
    color: { type: String, default: 'primary' },
    loading: { type: Boolean, default: false },
  },
  computed: {
    tone(): string {
      const allowed = ['primary', 'success', 'warning', 'error', 'info']
      return allowed.includes(this.color) ? this.color : 'primary'
    },
  },
})
